/*eslint-disable*/
import React, { useState, useEffect } from 'react';
import { Search } from 'semantic-ui-react';
import _ from "lodash";
import Axios from 'axios';

import APP_CONSTANTS from '../../config/constants';



const SupportDocDropdown = ({
        field: { name },
        form: { setFieldValue },
        supportDocId,
        viewMode,
        ...props
    }) => {
        
        const [results, setResults] = useState([]);
        const [isLoading, setIsLoading] = useState(false);
        const [value, setValue] = useState("");
        
        const handleResultSelect = (e, { result }) => {
            setValue(result.title);
            setFieldValue(name, result.title);
            setFieldValue(supportDocId, result.key)
        }

        const handleSearchChange = (e, { value }) => {
            setIsLoading(true);  
            setFieldValue(name, value);
            let token = localStorage.getItem('isloggedIn');
            let userId = localStorage.getItem('userId');
            let customerNo = localStorage.getItem('customerNumber');
          

            Axios.get(`${APP_CONSTANTS.BASE_URL}masters/supportingDocumentType?customerNumber=${customerNo}&customerNo=${customerNo}&userId=${userId}&searchString=${value}`, {
                headers: {
                    'Accept': 'application/json',
                    'Content-Type': 'application/json', 
                    'Authorization': token
                }
            }).then((response => {

                setTimeout(() => {
                    let docArray = [];
                    response.data.resultSet.map((doc, docIndex) => {
                        let temp = {};
                        temp.key = doc.supportingDocumentTypeId
                        temp.title = doc.supportingDocumentTypeName
                        temp.item = doc

                        return docArray[docIndex] = temp
                    });
                    
                    setResults(docArray)

                }, 300, response)


                setResults(response.data.resultSet)
                setIsLoading(false)
            }))
                .catch(error => console.log(error))
                setIsLoading(false)
        }

    return (
        <Search
            selection={value.toString()}
            onResultSelect={handleResultSelect}
            onSearchChange={_.debounce(handleSearchChange, 500, {
                leading: true,
              })}
            results={results}
            value={value}
            disabled={viewMode}
            fluid
            loading={isLoading}
            {...props}
        />
    )
}

export default SupportDocDropdown